import Blue from "~/core";

new Blue({
	name: 'Map',
	selector: "#map",
	setup(map) {
		const target = map;
		const callback = createMap;
		const options = { threshold: 1.0};
		const observer = new IntersectionObserver(callback, options);
    const mapStyle = map.dataset.style;

		var apiKey = map.getAttribute("data-apikey");

		observer.observe(target);

		async function createMap([entry]) {
			if (!entry.isIntersecting) return;

			try {
				const { maps } = await loadMapsScript(apiKey);
				const target = entry.target;
				observer.disconnect();
				target.classList.add("loaded");
				// do stuff to create your map here
				// maps is the google maps object with all the functions and stuff
				// target is the root element for injecting the map
				window.mapMarkers = window.mapMarkers || [];
				let zoom = Number(map.getAttribute("data-zoom"));
				zoom = (zoom>0) ? zoom : 14;
				let centerLatitude = Number(map.getAttribute("data-center-latitude"));
				let centerLongitude = Number(map.getAttribute("data-center-longitude"));
				let center = (centerLatitude!=NaN&&centerLongitude!=NaN)?{lat: centerLatitude, lng: centerLongitude}:{};
				let mapObject = new google.maps.Map(map, {
					center: center,
					zoom: zoom,
					mapTypeControl: false,
					fullscreenControl: false,
					streetViewControl: false,
          styles: mapStyle === 'plain' ? getPlainStyles() : null
				});

				const colorSecondary = getComputedStyle(document.documentElement)
																.getPropertyValue('--color_secondary');
			
				const mapOverlay = new google.maps.Polygon({
					paths: mapOverlayCoords,
					strokeColor: colorSecondary,
					strokeOpacity: 0.8,
					strokeWeight: 3,
					fillColor: colorSecondary,
					fillOpacity: 0.35,
				})

				mapOverlay.setMap(mapObject);

				for(let i = 0; i < mapMarkers.length; i++) {
					const marker = new google.maps.Marker({
						position: mapMarkers[i].position,
						map: mapObject,
						title: mapMarkers[i].title,
						icon: mapMarkers[i].icon,
						animation: google.maps.Animation.DROP,
						clickable: true
					});
				}
				//
			} catch (err) {
				console.error(err);
			}
		}

		function loadMapsScript(key) {
			let gMapsInitialized = !window.google;
			let resolveGMaps;
			let rejectGMaps;

			const gMapsLoading = new Promise((resolve, reject) => {
				resolveGMaps = resolve;
				rejectGMaps = reject;
			});

			if (!key) {
				rejectGMaps("You must provide a GMaps API Key");
				return gMapsLoading;
			}

			return initGoogleMaps();

			function initGoogleMaps() {
				if (gMapsInitialized) return gMapsLoading;
				gMapsInitialized = true;
				window.alertGMapsLoaded = () => resolveGMaps(window.google);

				const script = document.createElement("script");
				script.async = true;
				script.defer = true;
				script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&callback=alertGMapsLoaded`;

				script.onerror = rejectGMaps;
				document.querySelector("head").appendChild(script);

				return gMapsLoading;
			}
		}		
		
	}
});


function getPlainStyles() {
  return [
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#bdbdbd"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#dadada"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#c9c9c9"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    }
  ];
}